<template>
  <div
      :class="visible ? 'toast visible' : 'toast'"
      :style="visible ? 'visibility:block;':'visibility:hidden'"
  >
    <slot/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Toast',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    activate(timeInSeconds: number): void {
      this.visible = true
      setTimeout(() => {
        this.visible = false;
      }, timeInSeconds * 1000);
    }
  }
})
</script>

<style scoped>
</style>
